import {CreateNewDocProps} from 'app/general/types';
import * as request from 'app/utils/request';

import * as urls from '../urls';

import {
  ListResponseType,
  ProcedureSerializedType,
  ProcedureVersionSerializedType,
} from 'sweet-types';

export const procedureDetailByHashidFetcher = (hashid: string): Promise<any> =>
  request.get(urls.getProcedureDetailURLByHashid(hashid));

export const procedureListFetcher = <A extends Record<string, any>>(
  args: A
): Promise<ListResponseType<ProcedureSerializedType>> =>
  request.get(urls.PROCEDURES_API_URL, args);

export const procedureDeleter = (url: string): Promise<any> => request.del(url);

export const procedurePatcher = (
  url: string,
  data: Partial<ProcedureSerializedType>
): Promise<ProcedureSerializedType> => request.patchJson(url, data);

export const procedureVersionPatcher = (
  versionURL: string,
  data: Partial<ProcedureVersionSerializedType>
): Promise<ProcedureVersionSerializedType> =>
  request.patchJson(versionURL, data);

export const procedureVersionsFetcher = (params: {
  [filter: string]: number | string;
}): Promise<ListResponseType<ProcedureVersionSerializedType>> =>
  request.get(urls.PROCEDURES_VERSIONS_API_URL, params);

export const procedureVersionDetailFetcher = (
  versionId: number
): Promise<ProcedureVersionSerializedType> =>
  request.get(urls.PROCEDURES_VERSIONS_API_URL + versionId + '/');

export const procedureVersionDeleter = (url: string): Promise<any> =>
  request.del(url);

export const procedureVersionApprover = (
  versionURL: string,
  options: {notify?: boolean; signoff?: boolean}
): Promise<ProcedureVersionSerializedType> =>
  request.postJson(urls.PROCEDURES_VERSION_APPROVE_API_URL, {
    url: versionURL,
    ...options,
  });

export const procedureCreator = (data: CreateNewDocProps): Promise<any> =>
  request.postJson(urls.PROCEDURES_API_URL, data);
